import { useMemo } from 'react';
import { CreateVideoClickTarget } from '../../../constants/Bi';
import { PageTabsNames } from '../../../constants/PageTabsNames';
import { biLogger } from '../../../services/biLogger';
import { Orientations } from '../useVideoMaker/videoMaker.types';

interface ITrackVideoMakerCreateVideoClick {
  target: CreateVideoClickTarget | Orientations;
  tabName: PageTabsNames;
}

export const useTrackCreateVideoClick = () =>
  useMemo(
    () => ({
      trackVideoMakerCreateVideoClick: ({
        target,
        tabName,
      }: ITrackVideoMakerCreateVideoClick) =>
        biLogger.videoMakerCreateVideoClick({
          target,
          tabName,
        }),
    }),
    [],
  );
